import store from 'Store'
// helpers
import { loadCards } from '../middleware/load-cards'
import { loadClients } from '../middleware/load-clients'
import { loadTemplates, loadTemplateDetails, loadTemplateEdit } from '../middleware/templates-load'

export default [
  {
    // TEAM DASHBOARD
    path: 'dashboard',
    meta: { user: 'employee', requireEmployee: true },
    component: () => import(/* webpackChunkName: "dashboard-team" */ 'Pages/DashboardTeam'),
    children: [
      // MY CARDS
      {
        path: '/',
        name: 'dashboard-team',
        beforeEnter: (to, from, next) => loadCards(from, next),
        component: () =>
          import(/* webpackChunkName: "dasboard-team-my-cards" */ 'Pages/DashboardTeamMyCards'),
        children: [
          {
            path: 'c/:card_id/:card_title',
            name: 'dashboard-team-modal',
            props: true,
            component: () =>
              import(/* webpackChunkName: "dashboard-team-modal" */ 'Pages/CardModalPage'),
          },
        ],
      },
      {
        // CARD LISTING
        path: '/actions',
        name: 'cards-listing',
        beforeEnter: (to, from, next) => loadCards(from, next),
        component: () =>
          import(/* webpackChunkName: "cardsListing" */ 'Pages/DashboardTeamCardsListing'),
        children: [
          {
            path: 'c/:card_id/:card_title',
            name: 'cards-listing-modal',
            props: true,
            component: () =>
              import(/* webpackChunkName: "cardsListingModal" */ 'Pages/CardModalPage'),
          },
        ],
      },
      {
        // CLIENTS LISTING
        path: '/clients',
        name: 'clients-listing',
        beforeEnter: (to, from, next) => loadClients(next),
        component: () =>
          import(/* webpackChunkName: "accounts-listing" */ 'Pages/DashboardTeamClientListing'),
      },
      {
        // TEMPLATES
        path: '/templates',
        name: 'templates-listing',
        meta: { requireEditor: false },
        component: () =>
          import(/* webpackChunkName: "templates-listing-page" */ 'Pages/TemplatesListingPage'),
        async beforeEnter(to, from, next) {
          // checking if already have templates
          if (store.state.templates.templates) return next()
          loadTemplates(next)
        },
        children: [
          {
            path: 't/:temp_id/:temp_title/details',
            name: 'template-details',
            props: true,
            beforeEnter: (to, from, next) => loadTemplateDetails(to, next),
            component: () =>
              import(
                /* webpackChunkName: "templates-single-details-page" */ 'Pages/TemplatesSingleDetailsPage'
              ),
          },
          {
            path: 't/:temp_id/:temp_title/edit',
            name: 'template-edit',
            meta: { requireEditor: true },
            props: true,
            beforeEnter: (to, from, next) => loadTemplateEdit(to, next),
            component: () =>
              import(
                /* webpackChunkName: "templates-single-edit-page" */ 'Pages/TemplatesSingleEditPage'
              ),
          },
        ],
      },
    ],
  },
]
